import React, { useState, useEffect, useMemo } from 'react';
import { Alert, TouchableOpacity, View } from 'react-native'

import api from "@/utils/api"
import tw from '@/styles/tailwind';
import Text from '@/components/Text';
import IcomoonIcon from '@/components/IcomoonIcon';
import { Illustration } from '@/components/Illustration';
// import BottomSheetModal from '@/components/BottomSheetModal';
import { useForm } from 'react-hook-form';
import useFormSubmit from '@/hooks/useFormSubmit';
import Input from '@/components/Forms/Input';
import Button from '@/components/Forms/Button';
import BottomSheetModal from '@/components/BottomSheet';
import LabelSwitch from '@/components/Forms/LabelSwitch';
import IconButton from '@/components/IconButton';
import Modal from '@/components/Modal';
import { Image } from 'expo-image';


function FileRow({ url, type, name, subtitle, onPress }) {

  return (
    <TouchableOpacity style={tw`row pl-2 pt-3 pb-3 border-b border-gray-200`} onPress={onPress}>
      {
        type == 'image' &&
        <Image source={url} style={tw`h-12 w-10 mr-2 rounded`} contentFit='cover' />
      }
      {
        type == 'xml' &&
          <Illustration name="iconXml" width={48} height={48} style={tw`self-center`} />
      }
      {
        type == 'pdf' &&
          <Illustration name="pdfIcon" width={48} height={48} style={tw`self-center`} />
      }
      {
        type == 'zip' &&
          <Illustration name="iconFile" width={48} height={48} style={tw`self-center`} />
      }

      <View style={tw`flex-1`}>
        <Text style={tw`text-gray-800`}>{name}</Text>
        <Text style={tw`text-sm text-gray-400`}>{subtitle}</Text>
      </View>

      <View style={tw``}>
        <IcomoonIcon name='chevron-right' color={tw.color('text-secondary')} style={tw`ml-1`} />
      </View>
    </TouchableOpacity>
  )
}


export default function PrintDocumentsModal({
  onRequestClose,
  documents,
}) {
  const printDocument = url => {
    const newWindow = window.open(url, "_blank");
    console.log(newWindow)

    if (!newWindow) {
      alert("El navegador bloqueó la ventana emergente");
      return;
    }

    newWindow.focus();
    newWindow.print();
    newWindow.close(); 
  }

  const printDocumentIframe = url => {
    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      alert('El navegador bloqueó la ventana emergente');
      return;
    }

    printWindow.document.write(`
    <html>
      <head>
        <title>Imprimir</title>
      </head>
      <body style="margin:0">
        <iframe src="${url}" style="border:0;width:100%;height:100vh;" onload="this.contentWindow.focus(); this.contentWindow.print();"></iframe>
      </body>
    </html>
  `);
    printWindow.document.close();
  }

  return (
    <Modal onRequestClose={onRequestClose} title='Imprimir documentos'>
      {
        documents?.map(document =>
          <FileRow
            url={document.url}
            name={document.name}
            subtitle={document.file_type == "image" ? 'Imagen' : `Archivo ${document.file_type}`}
            type={document.file_type}
            onPress={() => {
              printDocument(document.url)
            }}
          />
        )
      }
    </Modal>
  )
}